import { IconWithLabel } from '@/components/icons/IconWithLabel'

import styles from './Redirecting.module.scss'

const MESSAGE = 'Redirecting...'
const MESSAGE_LOADING = 'Loading...'

type Props = {
  variant?: 'loading' | false
}

export const Redirecting = ({ variant }: Props) => (
  <div className={styles.container} role='status'>
    <p className={styles.message}>
      <IconWithLabel iconAfter='spinner'>{variant === 'loading' ? MESSAGE_LOADING : MESSAGE}</IconWithLabel>
    </p>
  </div>
)
